import React from "react";
import { Row, Col, Tooltip } from "antd";
import Icon from "@ant-design/icons";
import dayjs from "dayjs";
import { EarlySvg } from "./AppointmentIcons";
import { AppointmentStatus } from "./AppointmentStatus";
import decodeHtmlEntities from "../../utils/UnexcapeString/UnexcapeString";
import { HeartIcon, MessageIcon } from "../Common/Icons/Icons";
import { FileImageOutlined } from "@ant-design/icons"

const AppointmentCard = React.memo(
    ({
        service,
    }) => {
        if (service.type === 3) {
            return (
                <div
                    style={{ zIndex: 10 }}
                >
                    <span
                        className='noselect'
                        style={{ fontSize: "14px", fontWeight: "bold" }}
                    >
                        Blocked Time
                    </span>
                    {service.notes && <MessageIcon />}
                    <br />
                    <span style={{ fontSize: "11px" }}>
                        {dayjs(service.start, "HH:mm").format("hh:mm")} -{" "}
                        {dayjs(service.end, "HH:mm").format("hh:mm")}
                    </span>
                    <br />
                    <span style={{ fontSize: "11px" }}>
                        {decodeHtmlEntities(service.notes)}
                    </span>
                </div>
            )
        }

        return (
            <Row
                style={{ zIndex: 10, }}
                justify='space-between'
                align='center'
            >
                <Col style={{ width: "100%", lineHeight: "16px" }}>

                    <span
                        className='noselect'
                    >
                        {service.preferredStaff && (
                            <Tooltip title='Client has a preferred staff'>
                                <HeartIcon />
                            </Tooltip>
                        )}

                        <span className='noselect'>
                            {" "}
                            {service.name.split(" ").slice(0, 5).join(" ")}{" "}
                            {service.name.split(" ").length > 5 && "... "}
                        </span>
                        {" "}
                        - {" "}

                        <span className='cancelDragAndDrop'>
                            {decodeHtmlEntities(service.clientName).split(" ").slice(0, 3).join(" ")} {" "}
                        </span>



                    </span>
                    <AppointmentStatus
                        status={service.status}
                        noMargin
                        displayText={false}
                    />


                    {service.notes && (
                        <Tooltip title='Client left a note'>
                            <MessageIcon />
                        </Tooltip>
                    )}{" "}
                    {(service.isEarlyCheckedIn) && (
                        <Tooltip title='Early checked in'>
                            <Icon component={EarlySvg} style={{ color: "red" }} />
                        </Tooltip>
                    )}{" "}
                    {service.images && service.images.length > 0 && (
                        <Tooltip title='Client uploaded images'>
                            <FileImageOutlined style={{ color: "#eb2f96" }} />
                        </Tooltip>
                    )}
                </Col>
                <Col style={{ width: "100%", textAlign: "center" }}>
                    <span style={{ fontSize: "11px" }}>
                        {dayjs(service.start, "HH:mm").format("hh:mm")} -{" "}
                        {dayjs(service.end, "HH:mm").format("hh:mm")} {" "}
                    </span>
                </Col>
            </Row>
        );
    }
);

// Custom equality function for React.memo
const areEqual = (prevProps, nextProps) => {
    return (
        prevProps.service.appointmentId === nextProps.service.appointmentId &&
        prevProps.service.start === nextProps.service.start &&
        prevProps.service.end === nextProps.service.end &&
        prevProps.service.duration === nextProps.service.duration &&
        prevProps.service.staff === nextProps.service.staff
    );
};

export default React.memo(AppointmentCard, areEqual);


// Note: UnpaidSvg and EarlySvg should be imported or shared to this component
